'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _layout = require('antd/lib/layout');

var _layout2 = _interopRequireDefault(_layout);

var _menu = require('antd/lib/menu');

var _menu2 = _interopRequireDefault(_menu);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _dropdown = require('antd/lib/dropdown');

var _dropdown2 = _interopRequireDefault(_dropdown);

var _spin = require('antd/lib/spin');

var _spin2 = _interopRequireDefault(_spin);

var _avatar = require('antd/lib/avatar');

var _avatar2 = _interopRequireDefault(_avatar);

var _headerSearch = require('../headerSearch');

require('./index.less');

var _localeContext = require('../../core/localeContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = exports.Header = (_dec = (0, _localeContext.localeContext)('Header', {
  searchPlaceholder: '站内搜索',
  profile: '个人中心',
  setting: '设置',
  logout: '退出登录'
}), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
  _inherits(Header, _React$PureComponent);

  function Header(props) {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

    _this.toggleClick = function () {
      _this.props.onCollapse(!_this.props.collapsed);

      _this._resizeTimer = setTimeout(function () {
        var event = document.createEvent('HTMLEvents');
        event.initEvent('resize', true, false);
        window.dispatchEvent(event);
      }, 600);
    };

    _this.handleChange = function (e) {
      _this.props.onChange && _this.props.onChange(e);
    };

    return _this;
  }

  _createClass(Header, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._resizeTimer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          loading = _props.loading,
          className = _props.className,
          hasSetting = _props.hasSetting,
          search = _props.search,
          style = _props.style,
          collapsed = _props.collapsed,
          nick = _props.nick,
          noSider = _props.noSider,
          avatar = _props.avatar,
          theme = _props.theme,
          route = _props.route,
          routes = _props.routes,
          subMenus = _props.subMenus,
          menu = _props.menu,
          brand = _props.brand,
          Link = _props.Link,
          orderKeys = _props.orderKeys,
          getResolvePath = _props.getResolvePath;

      var IMenu = this.props.Menu;
      return _react2.default.createElement(
        _layout2.default.Header,
        { className: 'j-com-header ' + className + (theme ? ' j-com-header-' + theme : ''), style: style },
        loading,
        noSider ? null : _react2.default.createElement(_icon2.default, {
          className: 'j-header-trigger',
          type: collapsed ? 'menu-unfold' : 'menu-fold',
          onClick: this.toggleClick }),
        _react2.default.createElement(
          'div',
          { className: 'j-header-right', style: { display: nick === false ? 'none' : '' } },
          search !== undefined ? search : _react2.default.createElement(_headerSearch.HeaderSearch, {
            className: 'j-header-action j-header-search',
            placeholder: this.getLocale('searchPlaceholder'),
            dataSource: [],
            onSearch: function onSearch(v) {
              return _this2.handleChange({ value: v, key: 'search' });
            },
            onPressEnter: function onPressEnter(v) {
              return _this2.handleChange({ value: v, key: 'search' });
            }
          }),
          nick ? _react2.default.createElement(
            _dropdown2.default,
            {
              overlay: _react2.default.createElement(
                _menu2.default,
                { className: 'j-header-menu', selectedKeys: [], onClick: this.handleChange },
                _react2.default.createElement(
                  _menu2.default.Item,
                  { key: 'profile' },
                  _react2.default.createElement(_icon2.default, { type: 'user' }),
                  this.getLocale('profile')
                ),
                hasSetting ? _react2.default.createElement(
                  _menu2.default.Item,
                  { key: 'setting' },
                  _react2.default.createElement(_icon2.default, { type: 'setting' }),
                  this.getLocale('setting')
                ) : null,
                _react2.default.createElement(_menu2.default.Divider, null),
                _react2.default.createElement(
                  _menu2.default.Item,
                  { key: 'logout' },
                  _react2.default.createElement(_icon2.default, { type: 'logout' }),
                  this.getLocale('logout')
                )
              ) },
            _react2.default.createElement(
              'span',
              { className: 'j-header-action j-header-account' },
              avatar && _react2.default.createElement(_avatar2.default, { size: 'small', className: 'j-header-avatar', src: avatar }),
              ' ',
              nick
            )
          ) : _react2.default.createElement(_spin2.default, { size: 'small', style: { marginLeft: 8 } })
        ),
        IMenu ? _react2.default.createElement(IMenu, { style: { marginLeft: noSider ? 70 : 0 }, route: route, routes: routes, subMenus: subMenus, menu: menu, orderKeys: orderKeys, Link: Link, getResolvePath: getResolvePath, brand: brand }) : null
      );
    }
  }]);

  return Header;
}(_react2.default.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  route: _propTypes2.default.object,
  routes: _propTypes2.default.array,
  subMenus: _propTypes2.default.object,
  menu: _propTypes2.default.any,
  brand: _propTypes2.default.object,
  Link: _propTypes2.default.any,
  Menu: _propTypes2.default.any,
  orderKeys: _propTypes2.default.array,
  getResolvePath: _propTypes2.default.func,

  collapsed: _propTypes2.default.bool,
  onCollapse: _propTypes2.default.func,
  avatar: _propTypes2.default.string,
  nick: _propTypes2.default.string,
  noSider: _propTypes2.default.bool,
  loading: _propTypes2.default.element,
  theme: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  hasSetting: _propTypes2.default.bool,
  search: _propTypes2.default.any
}, _class2.defaultProps = {
  className: ''
}, _temp)) || _class);


//////////////////
// WEBPACK FOOTER
// ./src/components/header/index.jsx
// module id = 21
// module chunks = 0